
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.263 33.33l-13.61 8.504-.154.089a4.005 4.005 0 01-5.191-1.198l-.126-.19L7.464 20.183a4.004 4.004 0 011.273-5.511l13.569-8.48a4.004 4.004 0 015.386 1.084l.126.19 12.718 20.353a4.004 4.004 0 01-1.084 5.386l-.189.125zm-15.6-24.967l-13.57 8.479c-.53.33-.77.956-.641 1.536L38.548 29.62a1.426 1.426 0 00-.11-.315l-.073-.132L25.685 8.88l-.085-.13a1.445 1.445 0 00-1.806-.461l-.132.073z","fill":"#535353"}})])
          )
        }
      }
    